<template>
  <div class="cs-container" style="min-width: 1400px">
    <context-menu :show="isShowContext" :options="optionsContext">
      <context-menu-item @click="onGoToSetting">
        <template v-slot:icon>
          <div class="min-w-[2rem]"><i class="flex1 fi fi-rr-settings"></i></div>
        </template>
        <template v-slot:label>설정</template>
      </context-menu-item>
      <context-menu-item @click="onLogout">
        <template v-slot:icon>
          <div class="min-w-[2rem]"><i class="flex1 fi fi-rr-sign-out-alt"></i></div>
        </template>
        <template v-slot:label>로그아웃</template>
      </context-menu-item>
    </context-menu>

    <div class="flex items-end mb-6">
      <h1 class="text-4xl font-bold">견적서 리스트</h1>
    </div>
    <div class="flex w-full h-full">
      <div class="w-full">
        <div v-if="false" class="flex justify-end mb-2 w-full text-left">
          <!-- <button
            class="flex items-center px-3 py-2 text-center cs-btn cs-btn-default"
            @click="onCreateEstimate"
          >
            <img src="../assets/images/plus.png" class="m-auto mr-1 w-5" />
            <span class="block mt-1 text-xs font-medium">견적서 생성</span>
          </button>
          <div class="w-[5px]"></div> -->
          <button
            class="flex items-center px-3 py-2 text-center cs-btn cs-btn-default"
            @click="onSubmit"
          >
            <img src="../assets/images/upload.png" class="m-auto mr-1 w-5" />
            <span class="block mt-1 text-xs font-medium">견적서 제출</span>
          </button>
          <div class="w-[5px]"></div>
          <button
            class="flex items-center px-3 py-2 text-center cs-btn cs-btn-default"
            @click="onDelete"
          >
            <img src="../assets/images/bin.png" class="m-auto mr-1 w-5" />
            <span class="block mt-1 text-xs font-medium">견적서 삭제</span>
          </button>
        </div>

        <div class="bg-white rounded-lg border border-line">
          <div class="flex items-center px-5 h-14 border-b border-line text-placeholder">
            <div class="" style="min-width: 40px">
              <input
                class="form-check-input"
                type="checkbox"
                :checked="allCheck"
                @change.stop="onChangeAllCheck"
              />
            </div>
            <div class="" style="min-width: 110px">번호</div>
            <div class="w-full">고객</div>
            <div class="" style="min-width: 110px">모델</div>
            <div class="" style="min-width: 110px">총 수량</div>
            <div class="" style="min-width: 180px">총 비용</div>
            <div class="" style="min-width: 150px">분석결과</div>
          </div>

          <div
            v-for="estimate in estimates"
            :key="estimate.id"
            class="estimate-item"
            @click="onGoToEstimate(estimate.id)"
          >
            <div style="min-width: 40px">
              <input
                class="form-check-input"
                id="pating"
                type="checkbox"
                :v-model="estimate.isCheck"
                :checked="estimate.isCheck"
                @click.stop="1"
                @change.stop="onChangeEsti(estimate)"
              />
            </div>
            <div
              class="text-desc"
              :class="[
                {'estimate-new-badge': !estimate.isRead},
                {'estimate-submit-badge': estimate.isActive},
              ]"
              style="min-width: 110px"
            >
              {{ estimate.id }}
            </div>
            <div class="flex w-full">
              <div>
                <thumbnail
                  :size="'3.6rem'"
                  :url="estimate.thumbnailUrl"
                  :defaultIcon="false"
                  :customCss="'w-16 h-16 bg-layout md:w-28 md:h-28'"
                  :borderWidth="1"
                  :borderColor="'#c0c2c4'"
                  :round="'5px'"
                >
                  <template v-slot:default-icon
                    ><i class="flex fi fi-tr-cubes text-placeholder" style="font-size: 3.5rem"></i
                  ></template>
                </thumbnail>
              </div>
              <div class="m-auto ml-4">
                <div class="mr-5 font-semibold cs-ellipsis1" style="max-width: 230px">
                  {{ estimate.clientName }}
                </div>
                <div
                  class="overflow-hidden mr-5 text-sm text-desc"
                  style="max-width: 270px; line-height: 1rem"
                >
                  {{ estimate.clientCompany }}
                </div>
                <div
                  class="text-sm text-placeholder"
                  style="margin-top: 0.25rem; line-height: 1rem"
                >
                  {{ dateConvertYMDHM(new Date(estimate.createdAt).getTime() / 1000) }}
                </div>
              </div>
            </div>
            <div class="text-placeholder" style="min-width: 110px">{{ estimate.totalCount }}개</div>
            <div class="text-placeholder" style="min-width: 110px">
              {{ estimate.totalQuantity }}개
            </div>
            <div class="font-semibold" style="min-width: 180px">
              {{ numberToComma(estimate.totalCost) }}원
            </div>
            <div class="text-placeholder" style="min-width: 150px">
              <div
                class="font-semibold"
                :class="['analysis-type-' + estimate.modelAnalysis]"
                data-analysis="pass"
              >
                {{ totalAnalysis(estimate.modelAnalysis) }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="isShowPaging" class="mt-10">
          <BasicPagination
            :page-count="estimateSearchCount"
            :page-range="5"
            :margin-pages="1"
            :show-first-last-buttons="false"
            :show-prev-next-buttons="false"
            @pageSelected="onPage"
          >
            <template v-slot:breakViewContent
              ><i class="fi fi-br-menu-dots text-lightgray"></i
            ></template>
            <template v-slot:pageContent="slotProps">
              <button class="text-xl text-placeholder">{{ slotProps.pageNumber }}</button>
            </template>
            <template v-slot:currentPageContent="slotProps">
              <button class="text-xl font-bold text-third">{{ slotProps.pageNumber }}</button>
            </template>
          </BasicPagination>
        </div>
      </div>
      <div class="px-2" style="min-width: 330px; max-width: 330px">
        <div class="estimate-sticky">
          <div class="overflow-hidden w-full rounded-md border estimate-content border-line">
            <div class="flex relative justify-center items-center px-7 py-3 bg-black">
              <img class="sub-logo" src="../assets/images/logo.png" />
              <button class="contextmenu" @click="onContextMenu($event)">
                <i class="text-white fi fi-br-menu-dots-vertical"></i>
              </button>
              <!-- <div class="flex justify-between w-20">
              <button @click="onGoToSetting"><i class="flex text-3xl text-white fi fi-rr-settings"></i></button>
              <button><i class="flex text-3xl text-white fi fi-rr-sign-out-alt"></i></button>
            </div> -->
            </div>
            <div class="px-7 py-6 bg-white border-b border-line">
              <div class="flex justify-between font-normal">
                <span class="text-placeholder">전체 견적서</span>
                <span class="text-right font-semibold1"
                  >{{ numberToComma(estimateTotalCount) }}개</span
                >
              </div>
              <div class="flex justify-between mt-8 font-normal">
                <span class="text-placeholder">미확인 견적서</span>
                <span class="text-right font-semibold1"
                  >{{ numberToComma(estimateUnReadCount) }}개</span
                >
              </div>
              <div class="flex justify-between mt-8 font-normal">
                <span class="text-placeholder">제출한 견적서</span>
                <span class="text-right font-semibold1"
                  >{{ numberToComma(estimateSubmitCount) }}개</span
                >
              </div>
            </div>
            <div class="px-7 py-8 bg-white">
              <div class="flex justify-between font-normal">
                <div class="mt-1">총 비용</div>
                <div>
                  <span class="text-4xl font-extrabold text-right text-second">{{
                    numberToComma(estimateTotalCost)
                  }}</span>
                  <span class="text-lg font-bold text-right text-second"> 원</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="px-6 py-7 mt-3 w-full bg-white rounded-md border estimate-content-search overflow-hidden1 border-line"
          >
            <div class="h-[2.5rem]">
              <!-- <div class="text-placeholder">검색</div> -->
              <input-search
                ref="search"
                class="w-full"
                :keyword="''"
                @onSearch="onSearch"
                @onCancel="onCancel"
              ></input-search>
            </div>
            <div class="mt-5">
              <!-- <div class="text-placeholder">검색 기간</div> -->
              <div class="relative">
                <vue-datepicker
                  class="mt-2"
                  lang="ko"
                  range
                  position="right"
                  placeholder="검색 기간을 설정해주세요."
                  v-model="selectedDate"
                  date-format="{ year:'numeric', month:'2-digit', day:'2-digit' }"
                >
                </vue-datepicker>
                <i
                  v-if="2 === selectedDate.length"
                  class="fi fi-br-cross icon-datepicker"
                  style="font-size: 0.95rem"
                  @click="onDatePickerClear"
                ></i>
                <i v-else class="text-xl fi fi-rr-calendar-lines icon-datepicker"></i>
              </div>
            </div>
            <div v-if="true" class="flex justify-between mt-5 w-full text-left">
              <!-- <button
            class="flex items-center px-3 py-2 text-center cs-btn cs-btn-default"
            @click="onCreateEstimate"
          >
            <img src="../assets/images/plus.png" class="m-auto mr-1 w-5" />
            <span class="block mt-1 text-xs font-medium">견적서 생성</span>
          </button>
          <div class="w-[5px]"></div> -->
              <button
                class="flex items-center px-5 py-3 text-center cs-btn cs-btn-default"
                @click="onSubmit"
              >
                <img src="../assets/images/upload.png" class="m-auto mr-1 w-5" />
                <span class="block mt-1 text-xs font-medium">견적서 제출</span>
              </button>
              <div class="w-[5px]"></div>
              <button
                class="flex items-center px-5 py-3 text-center cs-btn cs-btn-default"
                @click="onDelete"
              >
                <img src="../assets/images/bin.png" class="m-auto mr-1 w-5" />
                <span class="block mt-1 text-xs font-medium">견적서 삭제</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <modal-setting v-if="isModalSetting" @onModalClose="onModalClose"></modal-setting>
  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.estimate-sticky {
  position: sticky;
  top: 1rem;
}
// .estimate-content {
//   position: sticky;
//   top: 1rem;
// }
// .estimate-content-search {
//   position: sticky;
//   top: 18rem;
// }

.sub-logo {
  height: 30px;
}

.contextmenu {
  position: absolute;
  top: 50%;
  right: 2rem;
  transform: translateY(-50%);
}

.badge-analysis {
  position: relative;
  width: 4rem;
  padding: 0.5rem;
  border-radius: 5px;
  text-align: center;

  &[data-analysis="pass"] {
    background-color: var(--theme-bg-success);
    color: var(--theme-color-font-success);
  }
}

.estimate-new-badge {
  position: relative;
  padding-left: 1.2rem;

  &::after {
    content: "N";
    position: absolute;
    top: -2px;
    left: 0px;
    padding: 0.25rem 0.3rem 0.13rem;
    border-radius: 3px;
    background-color: var(--theme-color-font-danger);
    color: #fff;
    font-size: 0.6rem;
    font-weight: 600;
  }
}

.estimate-submit-badge {
  position: relative;
  padding-left: 1.2rem;

  &::after {
    content: "S";
    position: absolute;
    top: -2px;
    left: 0px;
    padding: 0.25rem 0.3rem 0.13rem;
    border-radius: 3px;
    background-color: var(--theme-color-font-second);
    color: #fff;
    font-size: 0.6rem;
    font-weight: 600;
  }
}

.icon-datepicker {
  position: absolute;
  top: 50%;
  right: 0.75rem;
  transform: translateY(-50%);
}

.analysis-type {
  &-pass {
    color: var(--theme-color-font-pass);
  }
  &-caution {
    color: var(--theme-color-font-caution);
  }
  &-warn {
    color: var(--theme-color-font-warn);
  }
  &-fail {
    color: var(--theme-color-font-fail);
  }
}

.estimate-item {
  @apply flex items-center px-5 py-3 border-b border-line;
  transition: background 0.15s;
  cursor: pointer;

  &:hover {
    @apply bg-hover;
  }
}
</style>

<script setup>
/******************************************
 * 하이쓰리디 - 관리자 견적서 목록 화면
 ******************************************/
import {ref, computed, watch, onMounted} from "vue";
import {useRouter} from "vue-router";
import {storeToRefs} from "pinia";
import {toast} from "vue3-toastify";

import {OptionsStore} from "../store/options-store";
import {EstimatesStore} from "../store/estimates-store";
import {ModelStore} from "../store/model-store";

import {numberToComma, dateConvertYMDHM, removeCookie} from "../js/utils";

import ModalSetting from "./modals/modal-setting.vue";
import ModalClientSubmit from "./modals/modal-client-submit.vue";
import InputSearch from "../components/InputSearch.vue";
import Thumbnail from "../components/ThumbnailBox.vue";
import {AnalysisStatus, AnalysisStatusKo, Modals} from "../js/types";
import {CommonStore} from "../store/common-store";

const commonStore = CommonStore();
const {modalResult} = storeToRefs(commonStore);
const optionsStore = OptionsStore();
const estimatesStore = EstimatesStore();
const modelsStore = ModelStore();
const {
  estimates,
  estimateTotalCost,
  estimateTotalCount,
  estimateUnReadCount,
  estimateSubmitCount,
  estimateSearchCount,
} = storeToRefs(estimatesStore);

const router = useRouter();

const allCheck = ref(false);
const isShowContext = ref(false);
const optionsContext = ref({
  clickClose: true,
  zIndex: 3,
  minWidth: 130,
  x: 500,
  y: 200,
  onClose: () => {
    isShowContext.value = false;
  },
});
const selectedDate = ref([]);
const isModalSetting = ref(false);

onMounted(() => {
  optionsStore.reqGetOptions();
  estimatesStore.reqEstimates();
  modelsStore.clear();
});

watch(selectedDate, (value) => {
  if (value[0] && value[1]) {
    estimatesStore.setDate(value[0], value[1]);
    estimatesStore.reqEstimates();
  }
});
watch(modalResult, (newV) => {
  switch (newV.modalName) {
    case Modals.SubmiEstimate:
      allCheck.value = false;
      estimatesStore.reqSubmitEstimates();
      break;
    case Modals.EstimateTrash:
      allCheck.value = false;
      estimatesStore.reqDeleteEstimates();
      break;
  }
});

const isShowPaging = computed(() => {
  const pageLength = process.env.VUE_APP_PAGE_LENGTH;
  if (estimateSearchCount.value / parseInt(pageLength)) {
    return true;
  }
  if (estimateSearchCount.value % parseInt(pageLength)) {
    return true;
  }
  return false;
});

const totalAnalysis = (analysis) => {
  switch (analysis) {
    case AnalysisStatus.Fail:
      return AnalysisStatusKo.Fail;
    case AnalysisStatus.Warn:
      return AnalysisStatusKo.Warn;
    case AnalysisStatus.Caution:
      return AnalysisStatusKo.Caution;
    default:
      return AnalysisStatusKo.Pass;
  }
};

const onGoToSetting = () => {
  isModalSetting.value = true;
};
const onLogout = () => {
  removeCookie("token");
  router.push({
    name: "admin-signin",
  });
};
const onSearch = (keyword) => {
  estimatesStore.setPage(0);
  estimatesStore.setKeyword(keyword);
  estimatesStore.reqEstimates();
};
const onPage = (pageIdx) => {
  console.log("estimate list pageIdx");
  estimatesStore.setPage(pageIdx - 1);
  estimatesStore.reqEstimates();
  console.log("estimate list pageIdx = " + pageIdx);
};
const onCancel = () => {
  estimatesStore.setPage(0);
  estimatesStore.setKeyword("");
  estimatesStore.reqEstimates();
};
const onDatePickerClear = () => {
  selectedDate.value = [];
  estimatesStore.setDate(null, null);
  estimatesStore.reqEstimates();
};
const onContextMenu = (e) => {
  e.preventDefault();
  isShowContext.value = true;
  optionsContext.value.x = e.x;
  optionsContext.value.y = e.y;
};
const onGoToEstimate = (estimateId) => {
  router.push({
    name: "admin-estimate-detail",
    params: {
      estimateId: estimateId,
    },
  });
};
const onModalClose = () => {
  isModalSetting.value = false;
};

const onChangeAllCheck = () => {
  allCheck.value = !allCheck.value;
  estimatesStore.setAllChecked(allCheck.value);
};
const onChangeEsti = (estimate) => {
  if (!estimate.isCheck) {
    estimate["isCheck"] = true;
  } else {
    estimate.isCheck = false;
  }

  if (estimates.value.length === estimatesStore.checkedCount) {
    allCheck.value = true;
  } else {
    allCheck.value = false;
  }
};

const onCreateEstimate = () => {
  CommonStore().showModal(ModalClientSubmit, null);
};

const onSubmit = () => {
  if (!estimatesStore.checkedCount) {
    toast.warning("제출할 견적서를 선택해주세요.", {
      transition: toast.TRANSITIONS.SLIDE,
      position: toast.POSITION.TOP_CENTER,
    });
    return;
  }

  const data = {
    modalName: Modals.SubmiEstimate,
    isShowCancel: false,
    title: "확인",
    content: "견적서를 일괄 제출 하시겠습니까?",
    result: {},
  };
  CommonStore().showGlobalModal(data);
};
const onDelete = () => {
  if (!estimatesStore.checkedCount) {
    toast.warning("삭제할 견적서를 선택해주세요.", {
      transition: toast.TRANSITIONS.SLIDE,
      position: toast.POSITION.TOP_CENTER,
    });
    return;
  }

  const data = {
    modalName: Modals.EstimateTrash,
    isShowCancel: false,
    title: "확인",
    content: "견적서를 일괄 삭제 하시겠습니까?",
    result: {},
  };
  CommonStore().showGlobalModal(data);
};
</script>
